import styled from 'styled-components';
import { Color } from '@pegasus/ui-components/tokens/colors';
import { mediaMinWidth } from '@pegasus/ui-components/templates/media';

export const ModalWrapper = styled.div`
    background: ${Color.bright};
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    /* taking the same z-index value from Dialog */
    z-index: 5000;
    display: flex;
    flex-direction: column;

    /* react-transition-group classes */
    &.item-exit {
        opacity: 1;
        visibility: visible;
        transform: translate3d(0, 0, 0);
    }
    &.item-exit-active {
        opacity: 0;
        visibility: hidden;
        transform: translate3d(50px, 50px, 0);
        transition: all 0.3s ease-in-out;
    }
`;

export const Topbar = styled.div`
    margin-bottom: 20px;
    height: 60px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    ${mediaMinWidth.md} {
        height: 76px;
    }
`;

export const LogoWrapper = styled.div`
    svg {
        height: 20px;
        width: 150px;
    }
`;

export const CloseWrapper = styled.div`
    &:hover {
        cursor: pointer;
    }
`;

export const TopbarLayoutWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export const ContentWrapper = styled.div`
    margin-top: 104px;
    width: 100%;
`;
